// extracted by mini-css-extract-plugin
export var light = "style-module--light--60fd4";
export var qrCode = "style-module--qrCode--d2452";
export var qrImage = "style-module--qrImage--37938";
export var qrSection = "style-module--qrSection--c9198";